<script setup>
  defineProps({
    color: {
      type: String,
      default: 'primary'
    },
    interactive: {
      type: Boolean,
      default: true
    }
  })
</script>

<template>
  <span
    class="px-2 py-1 w-fit inline-flex items-center rounded-full text-xs font-medium ring-1 ring-inset"
    :class="{
      'bg-sky-50 text-sky-700 ring-sky-600/20': color === 'primary' || color === 'sky',
      'bg-slate-50 text-slate-700 ring-slate-600/20': color === 'secondary' || color === 'slate',
      'bg-emerald-50 text-emerald-700 ring-emerald-600/20': color === 'green',
      'bg-indigo-50 text-indigo-700 ring-indigo-600/20': color === 'indigo',
      'bg-blue-50 text-blue-700 ring-blue-600/20': color === 'blue',
      'bg-cyan-50 text-cyan-700 ring-cyan-600/20': color === 'cyan',
      'bg-amber-50 text-amber-700 ring-amber-600/20': color === 'amber',
      'bg-teal-50 text-teal-700 ring-teal-600/20': color === 'teal',
      'bg-violet-50 text-violet-700 ring-violet-600/20': color === 'violet',
      'bg-orange-50 text-orange-700 ring-orange-600/20': color === 'orange',
      'bg-purple-50 text-purple-700 ring-purple-600/20': color === 'purple',
      'bg-fuchsia-50 text-fuchsia-700 ring-fuchsia-600/20': color === 'fuchsia',
      'bg-pink-50 text-pink-700 ring-pink-600/20': color === 'pink',
      'hover:cursor-pointer hover:shadow-sm transition-all duration-300 ease-in-out': interactive
    }"
  >
    <slot />
  </span>
</template>
